// extracted by mini-css-extract-plugin
export default {"question-reaction-layout":"FeedCardReaction_question-reaction-layout__v0JaN"};